module.exports = __webpack_public_path__ + "static/media/schemeDetails.51798505.svg";